import React from 'react';
import './App.css';
import { Routes, Route } from "react-router-dom";
import LocationCode from './pages/LocationCode/LocationCode';
import Reporting from './pages/Report/Reporting';
import 'bootstrap/dist/css/bootstrap.min.css';



function App() {
  return (

    <Routes>
      <Route path="/" element={<LocationCode />} />
      <Route path="/location/:id" element={<Reporting />} />
    </Routes>

  )
}



export default App;
